import React, { useEffect, useState } from "react";
import { ProjectsData } from "../../Assets/resource/project.js";
import { Link, useParams } from "react-router-dom";
import GetInTouch from "../Components/GetInTouch.jsx";
import Header from "../../Shared/Header";
import Footer from "../../Shared/Footer";

export default function Projects() {
  const { projectCategory } = useParams();
  const [selectedCategory, setSelectedCategory] = useState("all");


  const [filterProject, setFilterProject] = useState([]);

  useEffect(() => {
    // let filter =
    //        projectCategory == "development"
    //       ? ProjectsData.filter(
    //           (p) => p.category == "frontend" || p.category == "fullstack"
    //         )
    //     : ProjectsData.filter((p) => p.category === projectCategory);

    let filter;
    if (projectCategory == 'all' ) {
      filter = ProjectsData.filter(
        (p) => p.category == "frontend" || p.category == "fullstack" || 'uiux'
      );
    } else if (projectCategory == 'development') {
      let filt = ProjectsData.filter((p) => p.category == "frontend" || p.category == "fullstack");

      filter = [
        ...filt.filter(p => p.category == 'fullstack'),
        ...filt.filter(p => p.category == 'frontend')
      ]
      
    } else if (projectCategory == 'uiux') {
      filter =ProjectsData.filter((p) => p.category == "uiux");
    }

    setFilterProject(filter || []);
  }, [projectCategory]);

  console.log(projectCategory, filterProject);


  return (
    <section id="projects">
      <Header />
      <div className="md:pt-6 pb-24">
        <div className="w-[90%] md:w-[80%] mx-auto h-[80vh] md:h-[65vh] mt-6 mb-6 md:mt-10 md:mb-12 flex items-center justify-center">
          <div>
            <div className="md:flex hidden items-center md:justify-center bg-[0A0A0A] md:gap-2 gap-1 py-2 rounded">
              <div className="md:w-[8px] md:h-[8px] w-[7px] h-[7px] bg-green-400 text-white rounded-full"></div>
              <h6 className="md:text-sm text-[12px] text-slate-200">
                Featured
                <span className="hidden ml-1 md:inline-block"> Projects</span>:
              </h6>
              <ul className="flex gap-1 md:gap-2.5 text-[13px] text-slate-200">
                {projectCategory == "uiux" && (
                  <li className="px-2 md:px-4 py-1 text-[12px] md:text-[14px] border border-slate-700 rounded-full cursor-pointer hover:bg-slate-600/30 hover:text-white">
                    <Link to="">UX ✹ UI</Link>
                  </li>
                )}
                {projectCategory == "development" && (
                  <>
                    <li className="md:px-3 px-2 md:text-sm text-[12px] py-1 border border-slate-800 rounded-full cursor-pointer hover:bg-slate-500/10 hover:text-white">
                      <Link to="">Frontend</Link>
                    </li>
                    <li className="md:px-3 px-2 md:text-sm text-[12px] py-1 border border-slate-800 rounded-full cursor-pointer hover:bg-slate-500/10 hover:text-white">
                      <Link to="">Fullstack</Link>
                    </li>
                  </>
                )}
                {projectCategory == "all" && (
                  <>
                    <li className="md:px-3 px-2 md:text-sm text-[12px] py-1 border border-slate-800 rounded-full cursor-pointer hover:bg-slate-500/10 hover:text-white">
                      <Link to="/project/uiux">UI & UX</Link>
                    </li>
                    <li className="md:px-3 px-2 md:text-sm text-[12px] py-1 border border-slate-800 rounded-full cursor-pointer hover:bg-slate-500/10 hover:text-white">
                      <Link to="/project/development">Frontend</Link>
                    </li>
                    <li className="md:px-3 px-2 md:text-sm text-[12px] py-1 border border-slate-800 rounded-full cursor-pointer hover:bg-slate-500/10 hover:text-white">
                      <Link to="/project/development">Fullstack</Link>
                    </li>
                  </>
                )}
              </ul>
            </div>
            <h1 className="text-[36px] leading-[1] md:text-[60px] font-semibold text-left mt-3 mb-4 md:text-center text-[#f7f7f7]">
              {projectCategory == "uiux" && (
                // <>CreatingUI/UX that feels more easy to use for Users</>
                <>
                  <span>
                    Creating Interfaces & Experiences that feel simple, natural
                    & easy for every Users{" "}
                  </span>
                  <span className="hidden md:inline-block ml-[2px]">
                    {" "}
                    to use
                  </span>
                </>
              )}
              {projectCategory == "development" && (
                // <>Turning design into working Code that can feel</>
                <>
                  Turning designs into real
                  <span className="hidden ml-[8px] md:inline-block">
                    {" "}
                    working
                  </span>
                  things, blending code & creativity to make something people
                  can feel
                </>
              )}
              {projectCategory == "all" && (
                // <>Explore projects in UI/UX & Development</>
                <>
                  Explore new projects in UI/UX & Development, learning and
                  growing with each experience
                </>
              )}
            </h1>
            <h5 className="text-gray-200/80 text-[18px] md:text-[20px] md:mt-4 mt-2 mb-1 md:mb-2 text-left md:text-center">
              {projectCategory == "uiux" && (
                <>
                  A collection of UI/UX Work that reflects my knowldege about
                  product design.
                </>
              )}
              {projectCategory == "development" && (
                <>
                  Showcasing how I turning design into live product using JS
                  echo-system.
                </>
              )}
              {projectCategory == "all" && (
                <>
                  Here you will find a collection of my projects from intuitive
                  UI/UX to development solution
                </>
              )}
              {projectCategory == "uiux" ? `` : " "}
            </h5>

            <div className="flex md:justify-center items-center text-center">
              {projectCategory == "uiux" && (
                <div className="mt-2 flex md:gap-4 gap-2 text-center md:justify-center">
                  <a
                    href="https://dribbble.com/amir_hosen"
                    target="_blank"
                    className=" flex items-center gap-4 mt-2 md:mt-4 text-center pl-6 pr-4 py-2.5 rounded-full inline-block border border-violet-400/20 bg-gradient-to-b to-[#0f1916] from-[#263435] hover:from-blue-600/80 hover:to-blue-800/90 text-[16px] md:text-[16px] text-center text-[#f1f1f1] "
                  >
                    <span className="text-[15px] md:text-[16px]">Dribble</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 14 14"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                      >
                        <path d="M7 13.25c4 0 6.25-2.25 6.25-6.25S11 .75 7 .75S.75 3 .75 7S3 13.25 7 13.25" />
                        <path d="M1.978 11.175c2.343-2.155 4.645-3.2 6.956-3.56c1.425-.224 2.854-.187 4.297.01M.824 5.799a13.64 13.64 0 0 0 6.812-.9c1.75-.706 3.127-1.68 3.944-2.569" />
                        <path d="M4.24 1.199a13.9 13.9 0 0 1 3.396 3.7c.563.901.987 1.819 1.298 2.715c.692 1.995.82 3.885.65 5.25" />
                      </g>
                    </svg>
                  </a>

                  <a
                    href="https://drive.google.com/file/d/1_a1sAmDyzh92N-lVRwcVNr_T4fx5wQ3R/view?usp=drive_link"
                    target="_blank"
                    className="flex items-center gap-4 mt-2 md:mt-4 text-center pl-6 pr-2 py-2.5 rounded-full inline-block border border-violet-400/20 border-violet-400/20 bg-gradient-to-b to-[#0f1916] from-[#263435] hover:from-blue-600/80 hover:to-blue-800/90 text-[16px] md:text-[16px] text-center text-[#f1f1f1] "
                  >
                    Download Resume
                    <span className="w-[26px] h-[26px] flex items-center justify-center bg-white rounded-full text-black">
                      {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 21"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m6.5 10.5l4 4.232l4-4.191m-4-7.041v11m-6 3h12"
                        stroke-width="1"
                      />
                    </svg> */}
                      <svg
                        className="rotate-45"
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="m12.354 5.646l5 5a.5.5 0 0 1-.708.708L12.5 7.207V18a.5.5 0 0 1-1 0V7.207l-4.146 4.147a.5.5 0 0 1-.708-.708l5-5a.5.5 0 0 1 .708 0"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
              )}
              {projectCategory == "development" && (
                <div className=" mt-2 flex md:gap-4 gap-2 text-center md:justify-center">
                  <a
                    href="https://github.com/amiribnjaman"
                    target="_blank"
                    className=" flex items-center gap-4 mt-2 md:mt-4 text-center pl-6 pr-3 py-2.5 rounded-full inline-block border border-violet-400/20 bg-slate-500/10 hover:bg-blue-600/80"
                  >
                    <span className="text-[15px] md:text-[16px]">Github</span>

                    {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M12 24c6.63 0 12-5.37 12-12S18.63 0 12 0S0 5.37 0 12s5.37 12 12 12M1 12C1 5.92 5.92 1 12 1c6.07 0 11 4.92 11 11c0 4.86-3.15 8.98-7.53 10.4c-.547.109-.747-.237-.747-.528l.005-.614c.005-.568.013-1.42.013-2.41c0-1.04-.346-1.69-.747-2.04c2.46-.273 5.03-1.2 5.03-5.43c0-1.2-.419-2.19-1.13-2.95c.109-.273.492-1.4-.109-2.91c0 0-.93-.291-3.03 1.13a10.6 10.6 0 0 0-2.75-.364c-.93.001-1.86.124-2.75.364c-2.1-1.42-3.03-1.13-3.03-1.13c-.602 1.51-.219 2.64-.11 2.91a4.3 4.3 0 0 0-1.13 2.95c0 4.23 2.57 5.17 5.01 5.43c-.31.273-.602.765-.693 1.48c-.638.292-2.22.765-3.21-.911c0 0-.583-1.06-1.7-1.13c0 0-1.08 0-.073.674c0 0 .729.328 1.22 1.6c0 0 .638 1.97 3.7 1.31c0 .596.008 1.18.013 1.58l.005.463c0 .291-.2.638-.747.528c-4.37-1.46-7.53-5.57-7.53-10.4z"
              clip-rule="evenodd"
            />
          </svg> */}

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 48 48"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M24 2.5a21.5 21.5 0 0 0-6.8 41.9c1.08.2 1.47-.46 1.47-1v-3.65c-6 1.3-7.24-2.88-7.24-2.88A5.7 5.7 0 0 0 9 33.68c-1.95-1.33.15-1.31.15-1.31a4.52 4.52 0 0 1 3.29 2.22c1.92 3.29 5 2.34 6.26 1.79a4.6 4.6 0 0 1 1.37-2.88c-4.78-.54-9.8-2.38-9.8-10.62a8.3 8.3 0 0 1 2.22-5.77a7.68 7.68 0 0 1 .21-5.69s1.8-.58 5.91 2.2a20.46 20.46 0 0 1 10.76 0c4.11-2.78 5.91-2.2 5.91-2.2a7.74 7.74 0 0 1 .21 5.69a8.28 8.28 0 0 1 2.21 5.77c0 8.26-5 10.07-9.81 10.61a5.12 5.12 0 0 1 1.46 4v5.9c0 .71.39 1.24 1.48 1A21.5 21.5 0 0 0 24 2.5"
                        stroke-width="2"
                      />
                    </svg>

                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="90"
                      height="90"
                      viewBox="0 0 64 64"
                      className="w-7 h-7"
                    >
                      <linearGradient
                        id="KpzH_ttTMIjq8dhx1zD2pa_52539_gr1"
                        x1="30.999"
                        x2="30.999"
                        y1="16"
                        y2="55.342"
                        gradientUnits="userSpaceOnUse"
                        spreadMethod="reflect"
                      >
                        <stop offset="0" stop-color="#6dc7ff"></stop>
                        <stop offset="1" stop-color="#e6abff"></stop>
                      </linearGradient>
                      <path
                        fill="url(#KpzH_ttTMIjq8dhx1zD2pa_52539_gr1)"
                        d="M25.008,56.007c-0.003-0.368-0.006-1.962-0.009-3.454l-0.003-1.55 c-6.729,0.915-8.358-3.78-8.376-3.83c-0.934-2.368-2.211-3.045-2.266-3.073l-0.124-0.072c-0.463-0.316-1.691-1.157-1.342-2.263 c0.315-0.997,1.536-1.1,2.091-1.082c3.074,0.215,4.63,2.978,4.694,3.095c1.569,2.689,3.964,2.411,5.509,1.844 c0.144-0.688,0.367-1.32,0.659-1.878C20.885,42.865,15.27,40.229,15.27,30.64c0-2.633,0.82-4.96,2.441-6.929 c-0.362-1.206-0.774-3.666,0.446-6.765l0.174-0.442l0.452-0.144c0.416-0.137,2.688-0.624,7.359,2.433 c1.928-0.494,3.969-0.749,6.074-0.759c2.115,0.01,4.158,0.265,6.09,0.759c4.667-3.058,6.934-2.565,7.351-2.433l0.451,0.145 l0.174,0.44c1.225,3.098,0.813,5.559,0.451,6.766c1.618,1.963,2.438,4.291,2.438,6.929c0,9.591-5.621,12.219-10.588,13.087 c0.563,1.065,0.868,2.402,0.868,3.878c0,1.683-0.007,7.204-0.015,8.402l-2-0.014c0.008-1.196,0.015-6.708,0.015-8.389 c0-2.442-0.943-3.522-1.35-3.874l-1.73-1.497l2.274-0.253c5.205-0.578,10.525-2.379,10.525-11.341c0-2.33-0.777-4.361-2.31-6.036 l-0.43-0.469l0.242-0.587c0.166-0.401,0.894-2.442-0.043-5.291c-0.758,0.045-2.568,0.402-5.584,2.447l-0.384,0.259l-0.445-0.123 c-1.863-0.518-3.938-0.796-6.001-0.806c-2.052,0.01-4.124,0.288-5.984,0.806l-0.445,0.123l-0.383-0.259 c-3.019-2.044-4.833-2.404-5.594-2.449c-0.935,2.851-0.206,4.892-0.04,5.293l0.242,0.587l-0.429,0.469 c-1.536,1.681-2.314,3.712-2.314,6.036c0,8.958,5.31,10.77,10.504,11.361l2.252,0.256l-1.708,1.49 c-0.372,0.325-1.03,1.112-1.254,2.727l-0.075,0.549l-0.506,0.227c-1.321,0.592-5.839,2.162-8.548-2.485 c-0.015-0.025-0.544-0.945-1.502-1.557c0.646,0.639,1.433,1.673,2.068,3.287c0.066,0.19,1.357,3.622,7.28,2.339l1.206-0.262 l0.012,3.978c0.003,1.487,0.006,3.076,0.009,3.444L25.008,56.007z"
                      ></path>
                      <linearGradient
                        id="KpzH_ttTMIjq8dhx1zD2pb_52539_gr2"
                        x1="32"
                        x2="32"
                        y1="5"
                        y2="59.167"
                        gradientUnits="userSpaceOnUse"
                        spreadMethod="reflect"
                      >
                        <stop offset="0" stop-color="#1a6dff"></stop>
                        <stop offset="1" stop-color="#c822ff"></stop>
                      </linearGradient>
                      <path
                        fill="url(#KpzH_ttTMIjq8dhx1zD2pb_52539_gr2)"
                        d="M32,58C17.663,58,6,46.337,6,32S17.663,6,32,6s26,11.663,26,26S46.337,58,32,58z M32,8 C18.767,8,8,18.767,8,32s10.767,24,24,24s24-10.767,24-24S45.233,8,32,8z"
                      ></path>
                    </svg> */}
                  </a>

                  <a
                    href="https://drive.google.com/file/d/1EM-0RoKZoxV4Xx1CTyCCr3c2Z69CfsNy/view"
                    target="_blank"
                    className="flex items-center gap-4 mt-2 md:mt-4 text-center pl-6 pr-2 py-2.5 rounded-full inline-block border border-violet-400/20 bg-slate-500/10 hover:bg-blue-600/80"
                  >
                    Download Resume
                    <span className="w-[26px] h-[26px] flex items-center justify-center bg-white rounded-full text-black">
                      <svg
                        className="rotate-45"
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="m12.354 5.646l5 5a.5.5 0 0 1-.708.708L12.5 7.207V18a.5.5 0 0 1-1 0V7.207l-4.146 4.147a.5.5 0 0 1-.708-.708l5-5a.5.5 0 0 1 .708 0"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
              )}

              {/* 
              uiux- https://drive.google.com/file/d/1_a1sAmDyzh92N-lVRwcVNr_T4fx5wQ3R/view?usp=drive_link
              dev- https://drive.google.com/file/d/1EM-0RoKZoxV4Xx1CTyCCr3c2Z69CfsNy/view */}
            </div>
          </div>
        </div>

        <hr className="border-[#28282b]" />
        <div className="w-[90%] md:w-[80%] mx-auto flex justify-between items-start mt-10 mb-8">
          <div>
            {/* <Link
              to="/"
              className="mb-10 w-[100px] pr-2 h-[40px] border-slate-700 bg-gradient-to-r from-slate-500/20 to-slate-500/20 via-slate-500/10 rounded-lg flex items-center justify-center"
            >
              <svg
                className="-rotate-90 -mt-1"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 28 28"
              >
                <path
                  fill="currentColor"
                  d="m12.354 5.646l5 5a.5.5 0 0 1-.708.708L12.5 7.207V18a.5.5 0 0 1-1 0V7.207l-4.146 4.147a.5.5 0 0 1-.708-.708l5-5a.5.5 0 0 1 .708 0"
                />
              </svg>
              <span className="text-sm">Home</span>
            </Link> */}

            <h3 className="text-[#f1f1f1] mt-[28px] md:mt-12 mb-[12px] text-[36px] md:text-[44px] font-regular">
              Featured Project
            </h3>
            <h4 className="mb-[20px] text-[18px] md:text-[20px] md:w-[60%] font-regular text-[#fdfdfd]/90">
              {projectCategory == "uiux"
                ? `These UI/UX projects reflects my journey of creating interfaces that feel solving user problems by feeling user painpoint.`
                : "Here you'll see how I approch development, building apps that are practical, reliable and fullfil human needs"}
            </h4>
          </div>
        </div>
        {/* Project type/tags */}
        {/* Project type/tags */}
        {/* <div className="mb-8">
          <ul className="flex gap-2 md:gap-4 text-[11px] md:text-[13px] text-[#9D9DA5]">
            <li
              className={`${
                selectedCategory == "all" && "bg-slate-600/30 text-white"
              } px-3 md:px-4 py-1 text-[14px] border border-slate-700 rounded-full cursor-pointer hover:bg-slate-600/30 hover:text-white`}
              onClick={() => setSelectedCategory("all")}
            >
              All
            </li>
            <li
              onClick={() => setSelectedCategory("uiux")}
              className={`${
                selectedCategory == "uiux" && "bg-slate-600/30 text-white"
              } px-3 md:px-4 py-1 text-[14px] border border-slate-700 rounded-full cursor-pointer hover:bg-slate-600/30 hover:text-white`}
            >
              UI & UX
            </li>
            <li
              onClick={() => setSelectedCategory("frontend")}
              className={`${
                selectedCategory == "frontend" && "bg-slate-600/30 text-white"
              } px-3 md:px-4 py-1 text-[14px] border border-slate-700 rounded-full cursor-pointer hover:bg-slate-600/30 hover:text-white`}
            >
              Frontend
            </li>
            <li
              onClick={() => setSelectedCategory("fullstack")}
              className={`${
                selectedCategory == "fullstack" && "bg-slate-600/30 text-white"
              } px-3 md:px-4 py-1 text-[14px] border border-slate-700 rounded-full cursor-pointer hover:bg-slate-600/30 hover:text-white`}
            >
              Full Stack
            </li>
          </ul>
        </div> */}

        {/* Projects */}
        <div
          id="projects"
          className="w-[90%] md:w-[80%] mx-auto my-8 grid md:grid-cols-2 gap-x-6 md:gap-x-8 gap-y-[72px] grid-cols-1"
        >
          {/* {/*----single project 4----- */}
          {/* {console.log(filterProject.length)} */}
          {filterProject?.map((p) => (
            <div className="group w-full text-[#DEDEDE] inline-block relative text-[#9F9FA8]">
              {/* border-[#28282b] hover:bg-gradient-to-tl from-[#0f172a]/60 to-[#1E3A8A]/60 bg-gradient-to-r from-slate-500/10 hover:bg-gradient-to-r from-slate-500/10 inline-block to-slate-500/20 via-slate-500/20  inline-block to-slate-500/20 via-slate-500/20 hover:border-[#1E3A8A]/40 hover:shadow hover:shadow-[#1E3A8A]/90*/}
              <img
                className="w-full h-[400px] shadow-xl transform transition-transform duration-300 group-hover:scale-105"
                src={p.img}
                alt=""
              />

              <div className="text-[14px] mt-8 text-gray-200 font-regular uppercase ">
                {p.category == "uiux" && "UX  ✹  UI"}
                {p.category == "frontend" && "Frontend"}
                {p.category == "fullstack" && "Full-Stack"}
              </div>
              <a href={p.liveLink} target="_blank">
                <h3
                  title={p.title}
                  className="text-[24px] md:text-[32px] mt-[12px] mb-[16px] font-regular text-[#f1f1f1] hover:text-blue-500 line-clamp-1 leading-[1.2] px-1 md:px-0"
                >
                  {p.title}
                </h3>
              </a>
              <div>
                <ol className="text-[15px] text-left block text-gray-200/90">
                  <li className="block text-left line-clamp-2 px-1 md:px-0 -leading-1.5">
                    {p.description}
                  </li>
                </ol>

                {/*------PROJECT LIVE LINKS BUTTONS----- */}
                {/*------PROJECT LIVE LINKS BUTTONS----- */}
                <div className="gap-2 md:mt-4 mt-8 px-1 md:px-0 pb-2 md:pb-0 flex w-full">
                  {p.liveLink && (
                    <a
                      href={p.liveLink}
                      target="_blank"
                      className="flex justify-center items-center gap-4 md:px-6 px-[10px] py-3 rounded-xl border border-slate-700 inline-block border-violet-400/20 bg-gradient-to-b to-[#0f1916] from-[#263435] hover:from-blue-600/80 hover:to-blue-800/90 text-[16px] md:text-[16px] text-center text-[#f1f1f1] "
                    >
                      <span className="">
                        {p.category == "uiux" ? "Figma Design" : "Live Visit"}
                      </span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M5.576 13.481a3.5 3.5 0 0 0 4.95 4.95m2.473-7.423a3.5 3.5 0 0 1 0 4.95l-2.475 2.475m-2.475-7.425l-2.475 2.475m12.857-2.957a3.5 3.5 0 1 0-4.95-4.95M11.01 13a3.5 3.5 0 0 1 0-4.95l2.474-2.475M15.958 13l2.475-2.475"
                          stroke-width="1.5"
                        />
                      </svg>
                    </a>
                  )}

                  {p?.dribble && (
                    <a
                      href={p?.dribble}
                      target="_blank"
                      className="md:px-6 px-[10px] py-2.5 rounded-xl inline-block border border-slate-700 border-violet-400/20 hover:bg-blue-600/80 text-[15px] md:text-[16px] text-center text-[#f1f1f1] flex gap-5 items-center justify-center"
                    >
                      <span>{p?.dribble && "Dribble Shot"}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 14 14"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1"
                        >
                          <path d="M7 13.25c4 0 6.25-2.25 6.25-6.25S11 .75 7 .75S.75 3 .75 7S3 13.25 7 13.25" />
                          <path d="M1.978 11.175c2.343-2.155 4.645-3.2 6.956-3.56c1.425-.224 2.854-.187 4.297.01M.824 5.799a13.64 13.64 0 0 0 6.812-.9c1.75-.706 3.127-1.68 3.944-2.569" />
                          <path d="M4.24 1.199a13.9 13.9 0 0 1 3.396 3.7c.563.901.987 1.819 1.298 2.715c.692 1.995.82 3.885.65 5.25" />
                        </g>
                      </svg>
                    </a>
                  )}
                  {p?.frontLinkGit && p?.frontLinkGit && (
                    <a
                      href={p.frontLinkGit}
                      target="_blank"
                      className={` md:px-6 px-[10px] py-2.5 rounded-xl border border-slate-700 inline-block border-violet-400/20 bg-slate-500/10 flex gap-2 justify-center items-center hover:bg-blue-600/80 text-[15px] md:text-[16px] text-center text-[#f1f1f1]`}
                    >
                      <span>Frontend</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                        >
                          <path d="M9.096 21.25v-3.146a3.33 3.33 0 0 1 .758-2.115c-3.005-.4-5.28-1.859-5.28-5.798c0-1.666 1.432-3.89 1.432-3.89c-.514-1.13-.5-3.084.06-3.551c0 0 1.95.175 3.847 1.75c1.838-.495 3.764-.554 5.661 0c1.897-1.575 3.848-1.75 3.848-1.75c.558.467.573 2.422.06 3.551c0 0 1.432 2.224 1.432 3.89c0 3.94-2.276 5.398-5.28 5.798a3.33 3.33 0 0 1 .757 2.115v3.146" />
                          <path d="M3.086 16.57c.163.554.463 1.066.878 1.496c.414.431.932.77 1.513.988a4.46 4.46 0 0 0 3.62-.216" />
                        </g>
                      </svg>
                    </a>
                  )}
                  {p?.backLinkGit && p?.backLinkGit && (
                    <a
                      href={p.backLinkGit}
                      target="_blank"
                      className="md:px-6 px-[12px] py-2.5 rounded-xl border flex items-center justify-center gap-2 border-slate-700 inline-block border-violet-400/20 bg-slate-500/10 hover:bg-blue-600/80 text-[15px] md:text-[16px] text-center text-[#f1f1f1]"
                    >
                      <span>Backend</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                        >
                          <path d="M9.096 21.25v-3.146a3.33 3.33 0 0 1 .758-2.115c-3.005-.4-5.28-1.859-5.28-5.798c0-1.666 1.432-3.89 1.432-3.89c-.514-1.13-.5-3.084.06-3.551c0 0 1.95.175 3.847 1.75c1.838-.495 3.764-.554 5.661 0c1.897-1.575 3.848-1.75 3.848-1.75c.558.467.573 2.422.06 3.551c0 0 1.432 2.224 1.432 3.89c0 3.94-2.276 5.398-5.28 5.798a3.33 3.33 0 0 1 .757 2.115v3.146" />
                          <path d="M3.086 16.57c.163.554.463 1.066.878 1.496c.414.431.932.77 1.513.988a4.46 4.46 0 0 0 3.62-.216" />
                        </g>
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* GET INTOUCH SECTION */}
      <hr className="border-[#28282b]" />
      <GetInTouch />
      <hr className="border-[#28282b]" />
      <Footer />
    </section>
  );
}
